import React from 'react';
import { useIntl } from 'react-intl-next';
import { messages } from '../../../messages';
import { ProductStates } from '../../product-state-machine/product-state-machine-types';
import { LoadingSkeleton } from '../../autocorrection/autocorrection.styled';
import { AutocorrectAsyncWrapper } from '../../autocorrection';
export const sectionTitleRenderer = autocorrectEnabled => args => {
  const {
    formatMessage
  } = useIntl();
  const {
    productState
  } = args;
  const recentTitle = /*#__PURE__*/React.createElement("span", null, formatMessage(messages.common_recently_viewed_section_heading));
  const issuesTitle = /*#__PURE__*/React.createElement("span", null, formatMessage(messages.jira_issues_section_heading));
  switch (productState) {
    case ProductStates.PreQuerySuccess:
      return recentTitle;
    case ProductStates.PostQueryLoading:
      if (autocorrectEnabled) {
        return /*#__PURE__*/React.createElement(LoadingSkeleton, {
          "data-testid": 'autocorrection-loading-skeleton'
        });
      }
      return issuesTitle;
    case ProductStates.PostQuerySuccess:
      if (autocorrectEnabled) {
        return /*#__PURE__*/React.createElement(AutocorrectAsyncWrapper, {
          fallback: issuesTitle
        });
      }
      return issuesTitle;
    default:
      return issuesTitle;
  }
};